import React from 'react';
import { Cushion, Grid, Shimmer, Space } from '@pitchero/react-ui';
import BREAKPOINT from './constants';
import SelectionLoadingState from './selection-loading';

const LineupLoadingState = () => (
  <>
    <Space bottom="medium">
      <Cushion horizontal="large" component="div" style={{ textAlign: 'center' }}>
        <Shimmer width={300} height={300} style={{ margin: '0 auto' }} />
      </Cushion>
    </Space>
    <Grid
      columns="1fr 1fr"
      rowGap="medium"
      responsive={[
        {
          maxWidth: BREAKPOINT,
          props: { columns: '1fr' },
        },
      ]}
      columnGap="medium"
    >
      <div>
        <SelectionLoadingState />
        <SelectionLoadingState />
        <SelectionLoadingState />
        <SelectionLoadingState />
        <SelectionLoadingState />
        <SelectionLoadingState />
        <SelectionLoadingState />
        <SelectionLoadingState />
        <SelectionLoadingState />
      </div>
      <div>
        <SelectionLoadingState />
        <SelectionLoadingState />
        <SelectionLoadingState />
        <SelectionLoadingState />
        <SelectionLoadingState />
        <SelectionLoadingState />
        <SelectionLoadingState />
        <SelectionLoadingState />
        <SelectionLoadingState />
      </div>
    </Grid>
  </>
);

export default LineupLoadingState;
